import { useCallback } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import unescapedText from 'I18n/utils/unescapedText';
import { useMutation } from 'pulse/react';
import { GrantThreadAccessMutation } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadAccessGrantRpc.mutations';
import { GetThreadViewRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadViewRpc.resources';
import { getThreadPageParams } from './useTicketThread';
import { usageTracker } from '../utils/usageTracker';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const useGrantThreadAccess = (ticketId, threadId) => {
  const [mutate, {
    loading
  }] = useMutation(GrantThreadAccessMutation);
  const grantThreadAccess = useCallback(async contact => {
    const name = formatName({
      name: contact.name,
      email: contact.email
    });
    if (!threadId) {
      return false;
    }
    try {
      await mutate({
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketId,
          threadId,
          granteeVid: contact.contactId
        }
      }, {
        resolved: ({
          invalidate
        }) => {
          invalidate({
            resource: GetThreadViewRpc,
            params: getThreadPageParams({
              ticketId,
              threadId
            })
          });
        }
      });
    } catch (error) {
      FloatingAlertStore.addAlert({
        message: unescapedText('customer-portal-app.addPeople.failure', {
          name
        }),
        titleText: I18n.text('customer-portal-app.errors.error'),
        type: 'danger'
      });
      return false;
    }
    usageTracker.track('Customer Portal App', 'Threads Manipulated', {
      action: 'people-added',
      screen: 'ticket-details'
    });
    FloatingAlertStore.addAlert({
      message: unescapedText('customer-portal-app.addPeople.success', {
        name
      }),
      type: 'success'
    });
    return true;
  }, [mutate, ticketId, threadId]);
  return {
    grantThreadAccess,
    isGranting: loading
  };
};